import { ConfigService } from '@axo/config/ConfigService';
import { DropdownFieldUI } from '@axo/form/feature/form-input/DropdownField/DropdownFieldUI';
import { TextFieldUI } from '@axo/form/feature/form-input/TextField/TextFieldUI';
import { Purpose } from '@axo/shared/data-access/types';
import { useTranslation } from '@axo/shared/i18n';
import { Grid } from '@axo/ui-core/components/layout/item';
import { useFormContext } from 'react-hook-form';
import { useAxoFormContext } from '../../../../../../context/AxoForm/AxoForm';
import { useBroker } from '../../../../../../hooks/useBroker';
import { PurposeFormGroupData } from '../../../../FormData.fi.types';
import { debtCreditorsOptions } from '../../../config/globals';
import { gridColumns } from '../../../config/layouts/grid';
import { PurposeField } from '../../../fields';
import { accountNumberFieldOption, mainBankFieldOption } from './config';

export const PurposeFormGroup = () => {
  const { t } = useTranslation();

  const broker = useBroker();
  const { hasMainBank } = ConfigService.get('product-unsecured-loan').fields[
    broker
  ];

  const { watch } = useFormContext();

  const { axoFormData } = useAxoFormContext();

  const [creditCardDebt, personalDebt] = watch([
    'Debt/CreditCard/OutstandingAmount',
    'Debt/Personal/OutstandingAmount',
  ]).map(Number);

  const initialPurpose = axoFormData['LoanApplication/InitialPurpose'];
  const purpose = axoFormData['LoanApplication/Purpose'];

  const isTryingToRefinanceNoDebt =
    purpose === Purpose.RefinancingLoan &&
    creditCardDebt === 0 &&
    personalDebt === 0;

  const askPurpose =
    initialPurpose === Purpose.Other || isTryingToRefinanceNoDebt || !purpose;

  return (
    <>
      {askPurpose && (
        <Grid columns={gridColumns}>
          <PurposeField />
        </Grid>
      )}

      <Grid columns={gridColumns}>
        {hasMainBank && (
          <DropdownFieldUI<PurposeFormGroupData>
            name="LoanApplication/MainBank"
            label={t('MainBank.label')}
            data-testid="main-bank-input"
            options={debtCreditorsOptions}
            {...mainBankFieldOption}
          />
        )}

        <TextFieldUI<PurposeFormGroupData>
          name="LoanApplication/AccountNumber"
          label={t('AccountNumber.label')}
          format="**** **** **** **** **"
          data-testid="account-number-input"
          {...accountNumberFieldOption}
        />
      </Grid>
    </>
  );
};
